/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacSagittarius = createLucideIcon("zodiac-sagittarius", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M21 3 3 21", key: "1011np" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);

export { ZodiacSagittarius as default };
//# sourceMappingURL=zodiac-sagittarius.js.map
